import { useBoardLocale } from '@/components/board_portal/useBoardLocale';
import { boardDisplay } from '@/components/board_portal/boardPresentation';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMemberVotingApi } from '../api/voting'


export default function MemberVotingListPage({ clubCode, initialMotions = [] }) {
  const { t, locale, date } = useBoardLocale();
  const navigate = useNavigate()
  const { listOpenMotions } = useMemberVotingApi()
  const [motions, setMotions] = useState(initialMotions)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const didLoadRef = useRef(false)
  const lastClubCodeRef = useRef(clubCode)

  useEffect(() => {
    let cancelled = false
    async function loadMotions() {
      if (!clubCode) return
      if (lastClubCodeRef.current !== clubCode) {
        lastClubCodeRef.current = clubCode
        didLoadRef.current = false
      }
      if (didLoadRef.current) return
      didLoadRef.current = true
      setLoading(true)
      setError(null)
      try {
        const data = await listOpenMotions(clubCode)
        if (!cancelled) {
          setMotions(Array.isArray(data) ? data : [])
        }
      } catch (err) {
        if (!cancelled) {
          setError(err)
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    loadMotions()
    return () => {
      cancelled = true
    }
  }, [clubCode, listOpenMotions])

  if (loading && motions.length === 0) {
    return <div className="mp-voting"><div className="mp-card mp-voting__empty" aria-busy="true">{t('boardPortal.loadingOpenVotes')}{' '}</div></div>
  }

  if (error && motions.length === 0) {
    return <div className="mp-voting"><div className="mp-card mp-voting__empty" role="alert">{t('boardPortal.unableToLoadVotingMotions')}{' '}</div></div>
  }

  return (
    <div className="mp-voting">
      <div className="mp-voting__header">
        <div>
          <p className="mp-eyebrow">{t('boardPortal.boardVoting')}{' '}</p>
          <h1>{t('boardPortal.openMotions')}{' '}</h1>
          <p className="mp-muted">{t('boardPortal.reviewCurrentMotionsAndCastYourVoteBeforeTheDeadline')}{' '}</p>
        </div>
      </div>
      <div className="mp-voting__grid">
        {motions.length === 0 ? (
          <div className="mp-card mp-voting__empty">
            <p>{t('boardPortal.noOpenMotionsRightNow')}{' '}</p>
          </div>
        ) : (
          motions.map((motion) => (
            <div key={motion.id} className="mp-card mp-voting__card">
              <div>
                <p className="mp-voting__label">{t('boardPortal.closes')}{' '}{date(motion.closes_at, { dateStyle: 'medium', timeStyle: 'short', timeZone: motion?.presentation_timezone || 'UTC' })}</p>
                <h2>{motion.title}</h2>
                <p className="mp-muted">
                  {motion.tallies?.total || 0}{' '}{t('boardPortal.votes')}{' '}{motion.viewer_vote ? t('boardPortal.votedChoice', { choice: boardDisplay(t, 'vote', motion.viewer_vote) }) : t('boardPortal.notYetVoted')}
                </p>
              </div>
              <button
                type="button"
                className="mp-voting__cta"
                onClick={() => navigate(`/${clubCode}/voting/${motion.id}`)}
              >{t('boardPortal.reviewAndVote')}{' '}</button>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
